"use strict";
/* IMPORT */
var isPrimitive = require("is-primitive");
/* ARE SHALLOW EQUAL */
var isNaN = Number.isNaN;
function areShallowEqual(x, y) {
    if (x === y)
        return true;
    if (isNaN(x))
        return isNaN(y);
    if (isPrimitive(x) || isPrimitive(y))
        return x === y;
    for (var i in x)
        if (!(i in y))
            return false;
    for (var i in y)
        if (x[i] !== y[i])
            return false;
    return true;
}
/* EXPORT */
module.exports = areShallowEqual;
module.exports.default = areShallowEqual;
Object.defineProperty(module.exports, "__esModule", { value: true });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBLFlBQVk7O0FBRVosMENBQTRDO0FBRTVDLHVCQUF1QjtBQUVoQixJQUFBLG9CQUFLLENBQVc7QUFFdkIsU0FBUyxlQUFlLENBQUcsQ0FBTSxFQUFFLENBQU07SUFFdkMsSUFBSyxDQUFDLEtBQUssQ0FBQztRQUFHLE9BQU8sSUFBSSxDQUFDO0lBRTNCLElBQUssS0FBSyxDQUFHLENBQUMsQ0FBRTtRQUFHLE9BQU8sS0FBSyxDQUFHLENBQUMsQ0FBRSxDQUFDO0lBRXRDLElBQUssV0FBVyxDQUFHLENBQUMsQ0FBRSxJQUFJLFdBQVcsQ0FBRyxDQUFDLENBQUU7UUFBRyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUM7SUFFN0QsS0FBTSxJQUFNLENBQUMsSUFBSSxDQUFDO1FBQUcsSUFBSyxDQUFDLENBQUUsQ0FBQyxJQUFJLENBQUMsQ0FBRTtZQUFHLE9BQU8sS0FBSyxDQUFDO0lBRXJELEtBQU0sSUFBTSxDQUFDLElBQUksQ0FBQztRQUFHLElBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFBRyxPQUFPLEtBQUssQ0FBQztJQUV2RCxPQUFPLElBQUksQ0FBQztBQUVkLENBQUM7QUFFRCxZQUFZO0FBRVosa0JBQWUsZUFBZSxDQUFDIn0=